<template>
  <div class="m-news-page">
    <div class="news-header-wp">
      <div class="news-header">
        <h3 class="title-h3 tit-h3">
          {{title}}
        </h3>
        <time>{{time}}</time>
        <div class="item-cover">
          <img :src="coverUrl" alt="" />
        </div>
      </div>
    </div>

    <div class="news-content" v-html="content"></div>

    <!--<div class="news-details-container">
      <div class="news-details">
        <h1 class="title-big">{{title}}</h1>
        <p class="title-tip">
          <time>{{time}}</time>
          来源：<span>一维大成科技有限公司</span>
        </p>
        <div class="news-content" v-html="content"></div>
      </div>
    </div>-->
  </div>
</template>

<script>
  import fetch from '../server/index';
  import Bus from '../assets/js/Bus'

  export default {
    data () {
      return {
        id: '',
        coverUrl: '',
        title: '',
        time: '',
        content: ''
      }
    },
    watch: {
      id (n) {
        this.getContentById()
      }
    },
    methods: {
      getContentById () {
        fetch('/api/policyInfo/info',
          {id: this.id}
        ).then(res => {
          this.title = res.title;
          this.coverUrl = window.config.host + res.coverUrl;
          this.time = res.gmtPublish;
          this.content = res.content;
        }, err => {
          console.log(err);
        }).catch(e => {
        })
      }
    },
    mounted () {
      let self = this;

      self.id = self.$route.params.id;
      Bus.$bind('getDetail', function () {
        self.id = self.$route.params.id;
      })
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .m-news-page {
    $theme-color: #00ccff;
    min-height: 80%;
    .news-content{
      @include c-wrap();
    }

    .news-header-wp{
      @include c-wrap();
      border-bottom: 2px solid #f3f3f3;
      padding-top: .30rem;
      padding-bottom: .30rem;
      margin-bottom: .30rem;
    }
    .news-header{
      @include clear();
      padding-right: 3.05rem;
      position: relative;
      z-index: 2;
      h3{
        color: #00ccff;
        font-size: .34rem;
        line-height: 1.5em;
        font-weight: lighter;
        margin-bottom: .32rem;
        min-height: 3em;
      }
      time{
        font-size: .24rem;
        color: #c6c6c6;
        float: left;
        padding-left: 1.5em;
        background: url('../assets/images/i-time.png') no-repeat;
        -webkit-background-size: 1em;
        background-size: 1em;
      }
      .item-cover{
        width: 2.54rem;
        height: 1.70rem;
        overflow: hidden;
        position: absolute;
        right: 0;
        top: 0;
        img{
          display: block;
          width: 100%;
        }
      }
    }
    .news-content{
      font-size: .30rem;
      line-height: 1.8em;
      *{
        font-size: inherit!important;
        line-height: inherit!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/NewsDetails.vue